// extracted by mini-css-extract-plugin
module.exports = {"ruler-button":"_2787e5dfdf--ruler-button--BGj0G","pressed":"_2787e5dfdf--pressed--MGZFY","icon":"_2787e5dfdf--icon--KCdyX"};